import {
  Pin as PinIcon,
  Flights as FlightsIcon,
  CityView as CityViewIcon,
  Cars as CarsIcon,
} from 'pcln-icons'

const ICON_MAP = {
  POI: PinIcon,
  AIRPORT: FlightsIcon,
  CITY: CityViewIcon,
  PARTNER_LOC: CarsIcon,
}

export { ICON_MAP }
